import React from 'react'
import {
  styled,
  Button,
  DialogTitle,
  IconButton,
  DialogContent,
} from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { CLOSE_DIALOG } from '../../redux/dialogReducer'
export default function AIEntitlementDialog({ data, copyKey }) {
  const HintContainer = styled('div')(({ theme }) => ({
    marginBottom: theme.spacing(8),
  }))

  const StyledDialogTitle = styled(DialogTitle)(() => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  }))

  const CloseButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  }))
  const StyledContent = styled(DialogContent)(({ theme }) => ({
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
  }))
  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch({ type: CLOSE_DIALOG })
  }
  return (
    <>
      <StyledDialogTitle>
        <span /> {/* keeps space-between layout clean */}
        <CloseButton aria-label="close" onClick={handleClose} color="secondary">
          ✕
        </CloseButton>
      </StyledDialogTitle>

      <StyledContent>
        <HintContainer>
          {Object.entries(data).map(([key, value]) => (
            <div
              key={key}
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 12,
              }}
            >
              <strong style={{ marginRight: 6 }}>{key} :</strong>
              <span style={{ wordBreak: 'break-all', marginRight: 8 }}>
                {String(value)}
              </span>
              {key === copyKey && (
                <Button
                  onClick={() => navigator.clipboard.writeText(String(value))}
                  variant="contained"
                  color="primary"
                  size="small"
                >
                  Copy
                </Button>
              )}
            </div>
          ))}
        </HintContainer>
      </StyledContent>
    </>
  )
}
